module.exports = __webpack_public_path__ + "static/media/anatomia.afec140e.png";